import { useEffect, useState } from 'react';
import { TabDesign, TabLayout, Tabs, Theme } from '@nextgen-web-framework/all';
import type { AboutAmwayBrandsProps } from './types/propsTypes';
import Brands from './Brands';
import styles from './AboutAmwayBrands.module.scss';

const { PURPLE } = Theme;
const { HORIZONTAL } = TabLayout;
const { TRANSPARENT } = TabDesign;
const AboutAmwayBrands = (props: AboutAmwayBrandsProps) => {
  const currentIndex = props.brandData.tabsData.findIndex((tab) => tab.id === props.activeTabId);
  useEffect(() => {
    if (currentIndex >= 0) {
      setIndex(currentIndex);
    } else {
      setIndex(0);
    }
  }, [props.activeTabId]);
  const [index, setIndex] = useState(currentIndex);

  return (
    <div className={styles['amway-brand-container']} data-testid={'amway-brands-test-id'}>
      <h2 className={styles['amway-brand-title']}>{props.brandTitle}</h2>
      <div className={styles['amway-brand-tabs-scroller']}>
        <Tabs
          theme={PURPLE}
          layout={HORIZONTAL}
          selectedTab={index}
          onTabClick={(index, headerUrl) => {
            props?.callBack?.(headerUrl);
            setIndex(index);
          }}
          design={TRANSPARENT}
          tabList={props.brandData.tabsData}
        />
      </div>
      <div className={styles['brand-item-wrapper']}>
        <Brands tabData={props.brandData.tabsContent[index]} />
      </div>
    </div>
  );
};

export default AboutAmwayBrands;
export type { AboutAmwayBrandsProps };
